// hooks/useNetworkStatus.ts
import { offlineService } from '@services/offline/offline.service';
import { setIsConnected } from '@stores/utility-stores/connection';
import { useEffect } from 'react';

export function useNetworkStatus() {
  useEffect(() => {
    const probe = async () => {
      try {
        await offlineService.echo();
        setIsConnected(true);
      } catch {
        setIsConnected(false);
      }
    };

    const handleOnline = () => {
      // Verify connectivity when browser reports online.
      probe().catch(() => setIsConnected(false));
    };
    const handleOffline = () => {
      setIsConnected(false); // trust immediately
    };

    // Initial check on mount so state is correct at app launch.
    probe().catch(() => setIsConnected(false));

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
}
